import { observer } from "mobx-react-lite";
import { Message, Table } from "semantic-ui-react";
import { useEffect } from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useStore } from "../../app/stores/store";
import { PagingParams } from "../../app/models/pagination";
import { formatCurrency } from "../../app/common/util/functions";
import { ExpandedARIndexItemTicketDto } from "../../app/models/accountsReceivable";
import MyPaging from "../../app/common/form/MyPaging";


interface Props {
  customerId?: string;
}

export default observer(function ARTicketSearch({ customerId }: Props) {
  const { t } = useTranslation(["common", "search"]);

  const { accountsReceivableIndexStore } = useStore();
  const {
    loadExpandedARIndexItemTickets,
    expandedARTicketsPagination,
    setExpandedTicketsPagingParams,
    expandedARTicketsPagingParams,
    resetExpandedTicketsRegistry,
    getExpandedARIndexItemTickets,
    expandedARIndexItem,
  } = accountsReceivableIndexStore;

  useEffect(
    () => {
      if (customerId)
        loadExpandedARIndexItemTickets(customerId)

    },
    [loadExpandedARIndexItemTickets, customerId]
  )

  function listOnClick(value: number) {
    if (value > 0 && expandedARIndexItem && expandedARTicketsPagination && value < expandedARTicketsPagination?.totalPages + 1) {
      setExpandedTicketsPagingParams(new PagingParams(value));
      resetExpandedTicketsRegistry();
      loadExpandedARIndexItemTickets(expandedARIndexItem?.customerId!);
    }
  }

  return (
    <Table.Cell className="tableInTable textAlignRightNotMobile" colSpan={7}>
      <Table striped unstackable className="dnxTable no_padding">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
            {t("labels.invoiceNumber", { ns: "inventory" })}
            </Table.HeaderCell>
            <Table.HeaderCell>{t("date", { ns: "common" })}</Table.HeaderCell>
            <Table.HeaderCell>
              {t("description", { ns: "common" })}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("labels.ticketTotal", { ns: "inventory" })}
            </Table.HeaderCell>
            <Table.HeaderCell>{t("balanceDue", { ns: "accountsReceivable" })}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {getExpandedARIndexItemTickets && getExpandedARIndexItemTickets.length
            ? getExpandedARIndexItemTickets.map((arTck: ExpandedARIndexItemTicketDto) => (

              <Table.Row key={arTck.ticketId}>
                <Table.Cell
                  className="hoveredLink"
                  onClick={() => window.open(`/ticket/view/${arTck.ticketId}`, `_`)}
                  data-label={`${t("ticketnum", { ns: "common" })}:`
                  }>
                  {arTck.ticketNumber}
                </Table.Cell>
                <Table.Cell
                  data-label={`${t("date", { ns: "common" })}:`}
                >
                  {arTck.date ? format(new Date(arTck.date), "P") : null}
                </Table.Cell>
                <Table.Cell
                  data-label={`${t("description", { ns: "common" })}:`}
                >
                  {arTck.description}
                </Table.Cell>
                <Table.Cell
                  data-label={`${t("labels.ticketTotal", { ns: "inventory" })}:`}
                >
                  {formatCurrency(arTck.ticketTotal ?? 0)}
                </Table.Cell>
                <Table.Cell
                  data-label={`${t("balanceDue", { ns: "accountsReceivable" })}:`}
                >
                  {formatCurrency(arTck.balanceDue ?? 0)}
                </Table.Cell>
              </Table.Row>
            )) : (
              <Table.Row key={"noItems"}>
                <Table.Cell width="5" colSpan={5} className="noPaddingLeft">
                  <Message
                    color="yellow"
                    className="textAlignCenter fontStyleItalic"
                  >
                    {t("grid_noItems", { ns: "common" })}
                  </Message>
                </Table.Cell>
              </Table.Row>
            )}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.Cell colSpan="6">
              <MyPaging
                itemCount={expandedARTicketsPagination ? expandedARTicketsPagination.totalItems : 25}
                pageSize={expandedARTicketsPagingParams.pageSize}
                currentPage={expandedARTicketsPagination ? expandedARTicketsPagination.currentPage : 1}
                onClick={listOnClick}
                onChange={listOnClick}
                floated="right"
              ></MyPaging>
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </Table.Cell>
  );
});


